import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	({ transitions }) => ({
		divider: {
			margin: '20px 0',
			width: 1,
			flexGrow: 1,
			backgroundColor: 'rgb(194, 201, 209)',
		},
		content: {
			padding: '0 4px',
		},
		button: {
			position: 'relative',
			color: 'rgb(84, 104, 128)',
			fontFamily: 'Instrument Sans',
			'&:disabled': {
				color: 'rgb(84, 104, 128)',
			},
			'&:hover': {
				backgroundColor: 'transparent',
				'& $label': {
					opacity: 0,
					transition: transitions.create(['opacity']),
				},
				'& $icon': {
					opacity: 1,
					transition: transitions.create(['opacity'], { delay: 100 }),
				},
			},
		},
		label: {
			transition: transitions.create(['opacity'], { delay: 100 }),
		},
		icon: {
			position: 'absolute',
			top: '50%',
			left: '50%',
			transform: 'translate(-50%, -50%)',
			opacity: ({ children }) => (children ? 0 : 1),
			transition: transitions.create(['opacity']),
		},
	}),
	{ name: 'PageDivider' },
)

export default useStyles
